import { SERVICES } from "@/constants/services";

export const ServicesList = () => {
  return (
    <section data-testid="services-list" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20 space-y-8">
        {SERVICES.map(({ title, content, testId, icon: Icon }) => {
          return (
            <div
              key={testId}
              data-testid={testId}
              className="flex flex-col sm:flex-row gap-5 rounded-xl border border-[#E2E8F0] p-6 sm:p-8"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#0B4F37]/10 text-[#0B4F37]">
                <Icon className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <div>
                <h2 data-testid={`${testId}-title`} className="font-heading text-xl font-bold text-[#042D1F] mb-2">
                  {title}
                </h2>
                <p data-testid={`${testId}-content`} className="text-base text-slate-600 leading-relaxed">
                  {content}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
